"use client";

import { motion } from "framer-motion";
import {
  Waves,
  Sunset,
  Music,
  Gamepad2,
  Utensils,
  Car,
  Wind,
  Wifi,
  Droplets,
  ShieldCheck,
  Trees,
  Briefcase,
  type LucideIcon,
} from "lucide-react";
import { AMENITIES } from "@/lib/constants";

const ICON_MAP: Record<string, LucideIcon> = {
  Waves,
  Sunset,
  Music,
  Gamepad2,
  Utensils,
  Car,
  Wind,
  Wifi,
  Droplets,
  ShieldCheck,
  Trees,
  Briefcase,
};

export function AmenitiesSection() {
  return (
    <section id="amenities" className="section-padding bg-background">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-primary">
            Everything You Need
          </p>
          <h2 className="mt-3 font-playfair text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
            Amenities &amp; Features
          </h2>
        </motion.div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 md:gap-6">
          {AMENITIES.map((amenity, i) => {
            const Icon = ICON_MAP[amenity.icon] || Waves;
            return (
              <motion.div
                key={amenity.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                whileHover={{ scale: 1.04, y: -4 }}
                className="group flex flex-col items-center gap-3 rounded-xl border border-border bg-card/60 p-6 text-center transition-shadow hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5"
              >
                <div className="flex size-12 items-center justify-center rounded-full bg-primary/10 transition-colors group-hover:bg-primary/20">
                  <Icon className="size-6 text-primary" />
                </div>
                <h3 className="text-sm font-semibold text-foreground md:text-base">
                  {amenity.label}
                </h3>
                <p className="text-xs text-muted-foreground md:text-sm">
                  {amenity.detail}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
